<div [ngClass]="loading ? 'visually-hidden': ''">
    <form novalidate class="form-inline" [formGroup]="searchForm">
        <!-- Title/Header -->
        <p-toolbar aria-label="Advanced Search">
            <div class="p-toolbar-group-start">
                <span class="section-header">Advanced Search</span>
            </div>
        </p-toolbar>
        <!-- Search Bar Start -->
        <div class="form-group row mt-3 mb-3">
            <div class="col-sm-2 d-flex align-items-center ">
                <label class="float-end notMobile" for="keywords" id="keywordslabel">
                    <span class="form-label"><i class="pi pi-info-circle"
                            pTooltip="Finds documents with ALL keywords and phrases entered."></i>
                        Search Term(s): </span>
                </label>
                <label class="forMobile" for="keywords" id="keywordslabel">
                    <span class="form-label">
                        Search Term(s): </span>
                </label>
            </div>
            <div class="col-sm-7">
                <span class="p-fluid">
                    <p-autoComplete inputId="keywords" placeholder="Enter Search Term(s) - Searches Content & Properties"
                        formControlName="keywords" id="keywords" ariaLabel="Keywords" [minLength]="3" [maxlength]="500"
                        [suggestions]="aSugs" (completeMethod)="getSuggestions($event)" [showClear]="true" (onClear)="clearKeyword()"
                        (onSelect)="kwSuggestionSelected($event)">
                        <ng-template let-item pTemplate="item">
                            <div pTooltip="{{ item }}" tooltipPosition="top">{{ item }}</div>
                          </ng-template>
                    </p-autoComplete>
                    <div class="text-danger small mt-1" *ngIf="keywordLengthError">
                        Please enter at least 3 characters or leave the field empty.
                    </div>
                </span>
            </div>
            <div class="col-sm-3 text-center d-flex justify-content-end" style="display: inline !important;">
                <button type="submit" class="btn btn-secondary ps-5 pe-5 mt-2" (click)="submitForm()" [disabled]="!searchForm.valid || !isLibSelectionValid">
                            <i class="fas fa-search"></i> Search
                        </button>
            </div>
            <div class="text-center d-flex justify-content-end">

            </div>
        </div>
        <!-- Search Bar End -->

        <!-- Options Start -->
        <div class="form-group row mt-3 mb-3">
            <div class="col-12 col-sm-2">
                <label class=" notMobile" for="libOptions" id="libOptionslabel">
                    <span class="form-label"><i class="pi pi-info-circle"
                            pTooltip="Select the libraries/options for which to conduct the search"></i>
                        Options:</span>
                </label>
                <label class="forMobile" for="libOptions" id="libOptionslabel">
                    <span class="form-label" style="float: left;text-align: left;display: block; width: 100%;;">
                        Options:</span>
                </label>
            </div>
            <div class="col-sm-10">
                <span class="p-fluid">
                    <p-checkbox [binary]="true" formControlName="mainLibFilter" label="Public Main Library"
                        class="me-3" (onChange)="validateLibraries();"></p-checkbox>
                    <p-checkbox [binary]="true" formControlName="legacyLibFilter" label="Public Legacy Library"
                        class="me-3" (onChange)="validateLibraries();"></p-checkbox>
                    <p *ngIf="!isLibSelectionValid" class="text-danger text-sm m-2"><i class="pi pi-ban"></i> You must select at least 1 library to search!</p>
                </span>
            </div>
        </div>
        <!-- Options End -->

        <!-- Properties Start -->

        <div class="mt-3 row">
            <div class="d-flex align-items-top col-sm-2">
                <label class="float-end notMobile">
                <span class="form-label"><i
                        class="pi pi-info-circle"
                        pTooltip="Finds documents with ALL keywords, phrases, and/or date(s) entered for the selected property"></i>
                    Properties:</span>
                </label>
                <label class="forMobile">
                    <span class="form-label">
                        Properties:</span>
                    </label>
        </div>
            <div class="col-sm-10">
                <p-tabView styleClass="tabview-custom">
                    <p-tabPanel>
                        <ng-template pTemplate="header">
                            <i class="pi pi-info-circle"
                                pTooltip="The search query will use an AND operator between each of the properties in this tab. The document MUST MATCH ALL THE PROPERTIES."></i>
                            &nbsp; All (AND)
                        </ng-template>
                        <app-search-property-form [operatorType]="constants.property_operator_all" [mdItems]="mdItems"
                            [headerMsg]="allHeaderMsg" [props]="props(constants.property_operator_all)"
                            [searchForm]="searchForm" (addProperty)="addProp($event);"
                            (removeProperty)="removeProp($event)" (clearProperty)="clearProp($event)"
                            (selectProperty)="selectedProp($event)"></app-search-property-form>
                    </p-tabPanel>
                    <p-tabPanel>
                        <ng-template pTemplate="header">
                            <i class="pi pi-info-circle"
                                pTooltip="The search query will use an OR operator between each of the properties in this tab. If ANY of these properties match the document it will be returned."></i>
                            &nbsp; Any (OR)
                        </ng-template>
                        <app-search-property-form [operatorType]="constants.property_operator_any" [mdItems]="mdItems"
                            [headerMsg]="anyHeaderMsg" [props]="props(constants.property_operator_any)"
                            [searchForm]="searchForm" (addProperty)="addProp($event);"
                            (removeProperty)="removeProp($event)" (clearProperty)="clearProp($event)"
                            (selectProperty)="selectedProp($event)"></app-search-property-form>
                    </p-tabPanel>

                </p-tabView>
            </div>
        </div>

        <!-- Properties End -->

        <div class="col-sm-12 text-center d-flex justify-content-end mt-3">
            <button type="button" class="btn btn-primary me-3 ps-5 pe-5" (click)="clearSearch()">
                <i class="fas fa-circle-xmark"></i> Clear All
            </button>
            <button type="submit" class="btn btn-secondary ps-5 pe-5" (click)="submitForm()"
            [disabled]="!searchForm.valid || !isLibSelectionValid">
                <i class="fas fa-search"></i> Search
            </button>
        </div>
    </form>
    <!-- <p>{{ this.searchForm.value |json }}</p> -->
    <app-search-load-dialog [loadSearchVisible]="loadSearchVisible" (loadSearch)="executeLoadSearch($event)"
        (closeLoadSearch)="closeLoadDialog();"> </app-search-load-dialog>
</div>
<p-toast key="maxprops" position="bottom-left"></p-toast>
